module.exports = __webpack_public_path__ + "static/media/M101ws.ef35a1bd.pdf";